import Reflux from 'reflux'
import axios from 'axios'

import RecipesActions from '~/actions/recipes.js'

import apiUtils from '../helper/api.js'


export default class extends Reflux.Store {
	constructor() {
		super()

		this.listenables = RecipesActions

		this.state = {
			list: []
		}

		// auto hydrate
		this.get()
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	get() {
		// axios.get(`${apiUtils.getApiURL()}/recipes?filter[include]=recipeIngredients')
		axios.get(`${apiUtils.getApiURL()}/recipes`)
			.then((response) => {
				const list = response.data.map(
					(theRecipe) => {
						const newRecipe = theRecipe

						newRecipe.lastUpdated = (
							theRecipe.dateModified === null
							|| theRecipe.dateModified === ''
						)
							? theRecipe.dateCreated
							: theRecipe.dateModified

						return newRecipe
					}
				)

				this.setState({ list })
			})
	}
}



// WEBPACK FOOTER //
// ./src/stores/recipes.js